import React from "react";
import MSkeleton from "@/components/ui/atoms/MSkeleton";

/**
 * Placeholder shown while the reminders listing's very first fetch is in
 * flight — avoids the header/filter chip rendering instantly while the
 * actual reminder rows pop in a beat later. Not shown on subsequent
 * filter-driven refetches (see hasLoadedOnce in RemindersListing.tsx),
 * matching DocumentsLanding's same first-load-only convention.
 */
const RemindersListingSkeleton: React.FC = () => {
  return (
    <div className="flex w-full flex-col items-center gap-6">
      {/* Filter chip */}
      <MSkeleton className="h-7 w-full rounded-full" />

      {/* Reminder rows */}
      <div className="flex w-full flex-col gap-4">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="flex w-full items-center gap-3">
            <MSkeleton className="h-11 w-11 shrink-0 rounded-xl" />
            <div className="flex flex-1 flex-col gap-2">
              <MSkeleton className="h-4 w-1/2 rounded-full" />
              <MSkeleton className="h-3 w-1/3 rounded-full" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RemindersListingSkeleton;
